import TreeNode from '../../models/TreeNode';
import Scenario from '../../models/Scenario';
import Estimate from '../../models/Estimate';
import { SuccessCriteria, CriteriaSubject } from '../../models/project/SuccessCriteria';
import * as _ from 'lodash';
import { Option, Some } from 'tsoption';

let ScenarioCreator = {
  createScenario: function(scenario: TreeNode[]) {
    const probability = this.calculateScenarioProbability(scenario);

    let estimates = [new Estimate(CriteriaSubject.TIME_ESTIMATE, this.calculateWorkEstimate(scenario))];
    const customEstimate = ScenarioCreator.getScenarioCustomEstimate(scenario);
    if (customEstimate !== undefined) {
      estimates.push(new Estimate(CriteriaSubject.CUSTOM_ESTIMATE, customEstimate));
    }

    return new Scenario(scenario, probability, estimates);
  },
  
  calculateScenarioProbability: function(scenario: TreeNode[]) {
    return scenario.map(node => node.probability).reduce((acc, probability) => { return acc * probability; }, 1.0);
  },

  calculateWorkEstimate: function(scenario: TreeNode[]): number {
    return scenario.map(s => s.work_estimate).reduce((acc, estimate) => { 
      return acc + estimate.getOrElse(0);
    }, 0);
  },

  getScenarioCustomEstimate: function(scenario: TreeNode[]) {
    const lastNode = Option.of(_.last(scenario));
    
    return lastNode.flatMap((node) => node.custom_estimate).getOrElse(0);
  }
};

export default ScenarioCreator;


// WEBPACK FOOTER //
// ./src/services/scenario/ScenarioCreator.ts